import { SxProps, Theme } from "@mui/material";
import { DESKTOP_MIN_WIDTH, desktopMaxWidth, desktopPadding } from "@/taskpane/styles/responsive";

export const styles = {
  root: {
    p: 0,
    gap: 1,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    ...desktopPadding,
    ...desktopMaxWidth(600),
    margin: "0 auto",
  },
  backButton: (isSmallScreen: boolean) => ({
    position: "fixed",
    zIndex: 3,
    top: "20px",
    right: isSmallScreen ? "20px" : "calc((100% - 600px) / 2 + 20px)",
    borderRadius: "10px",
    // background: "linear-gradient(64deg, #1A2B4C 6.57%, #264C9D 98.29%)",
    background: "#3660f4",
    boxShadow: "0px 4px 0px 0px rgba(27, 72, 158, 0.12)",
  }),
  folderTitle: {
    marginLeft: "1rem",
    overflow: "hidden",
    color: "#09226B",
    textOverflow: "ellipsis",
    fontFamily: "Inter",
    fontSize: 13,
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
  contentContainer: {
    gridTemplateRows: "1fr 1fr",
    padding: 2,
    width: "100%",
    overflow: "auto",
    overflowY: "auto",
  },
  childrenContainer: {
    minHeight: 0,
    width: "100%",
  },
  subFolderSection: {
    minHeight: 0,
    mt: 1,
    width: "100%",
  },
  subFolderTitle: {
    fontWeight: "bold",
    fontSize: 14,
    color: "primary.dark",
    width: "100%",
    textAlign: "left",
  },
  subFolderCard: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  loadingContainer: {
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
  },
  validateButtonContainer: {
    alignItems: "flex-end",
    justifyContent: "flex-end",
    direction: "row",
    width: "100%",
    
  },
  modalUploadInProgress: {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,

  }
};
